<template>
	<el-dialog
		title="新增合同"
		:visible.sync="dialogVisible"
		width="40%"
		top="10vh"
		:close-on-click-modal="false"
		:before-close="handleClose"
		custom-class="depreciation-dialog">
		<el-form ref="formRef" :model="form" :rules="rules" size="small" label-position="top">
			<el-row :gutter="20">
				<!-- 合同编号 -->
				<el-col :span="12">
					<el-form-item label="合同编号" prop="contractNo">
						<el-input v-model="form.contractNo" placeholder="系统自动生成" disabled />
					</el-form-item>
				</el-col>

				<!-- 合同名称 -->
				<el-col :span="12">
					<el-form-item label="合同名称" prop="contractName">
						<el-input v-model="form.contractName" placeholder="请输入合同名称" />
					</el-form-item>
				</el-col>

				<!-- 甲方 -->
				<el-col :span="12">
					<el-form-item label="甲方">
						<el-input v-model="form.partyA" disabled />
					</el-form-item>
				</el-col>

				<!-- 乙方 -->
				<el-col :span="12">
					<el-form-item label="乙方" prop="partyB">
						<el-input v-model="form.partyB" placeholder="请选择乙方" readonly>
							<template #suffix>
								<el-popover width="600" placement="bottom" trigger="click">
									<el-table :data="tableDataB" max-height="450" style="width: 100%">
										<el-table-column prop="partnerName" label="伙伴名称" />
										<el-table-column prop="partnerCategory" label="伙伴类别" />
										<el-table-column prop="contactPerson" label="联系人" />
										<el-table-column prop="contactPhone" label="联系电话" />
										<el-table-column label="操作">
											<template #default="{ row }">
												<el-button type="primary" size="mini" @click="handleSelectB(row)">选择</el-button>
											</template>
										</el-table-column>
									</el-table>
									<el-button type="text" slot="reference">选择</el-button>
								</el-popover>
							</template>
						</el-input>
					</el-form-item>
				</el-col>

				<!-- 关联项目 -->
				<el-col :span="12">
					<el-form-item label="关联项目" prop="projectId">
						<el-input v-model="form.partyB" placeholder="请选择关联项目" readonly>
							<template #suffix>
								<el-popover width="600" placement="bottom" trigger="click">
									<el-table :data="tableData" max-height="450" style="width: 100%">
										<el-table-column prop="projectNo" label="项目编号" />
										<el-table-column prop="projectName" label="项目名称" />
										<el-table-column prop="businessType" label="经营类型" />
										<el-table-column prop="status" label="状态" />
										<el-table-column label="操作">
											<template #default="{ row }">
												<el-button type="primary" size="mini" @click="handleSelectB(row)">选择</el-button>
											</template>
										</el-table-column>
									</el-table>
									<el-button type="text" slot="reference">选择</el-button>
								</el-popover>
							</template>
						</el-input>
					</el-form-item>
				</el-col>

				<!-- 经营类型 -->
				<el-col :span="12">
					<el-form-item label="经营类型" prop="businessType">
						<el-select v-model="form.businessType" placeholder="请选择经营类型">
							<el-option label="创新租赁" value="创新租赁" />
							<el-option label="委托租售" value="委托租售" />
							<el-option label="增值服务" value="增值服务" />
						</el-select>
					</el-form-item>
				</el-col>

				<!-- 合同类型 -->
				<el-col :span="12">
					<el-form-item label="合同类型" prop="contractType">
						<el-select v-model="form.contractType" placeholder="请选择合同类型">
							<el-option label="定价合同" value="定价合同" />
							<el-option label="分成合同" value="分成合同" />
						</el-select>
					</el-form-item>
				</el-col>

				<!-- 应收金额 -->
				<el-col :span="12">
					<el-form-item label="应收金额（元）" prop="amount">
						<el-input
							type="number"
							v-model.number="form.amount"
							:min="0"
							style="width: 100%"
							placeholder="请输入应收金额" />
					</el-form-item>
				</el-col>

				<!-- 合同开始时间 -->
				<el-col :span="12">
					<el-form-item label="开始时间" prop="startDate">
						<el-date-picker v-model="form.startDate" type="date" placeholder="请选择开始时间" style="width: 100%" />
					</el-form-item>
				</el-col>

				<!-- 合同结束时间 -->
				<el-col :span="12">
					<el-form-item label="结束时间" prop="endDate">
						<el-date-picker v-model="form.endDate" type="date" placeholder="请选择结束时间" style="width: 100%" />
					</el-form-item>
				</el-col>

				<!-- 合同附件 -->
				<el-col :span="24">
					<el-form-item label="合同附件" prop="fileUrl">
						<FileUpload
							ref="upload"
							:limit="1"
							:accept="['jpg', 'png', 'jpeg', 'pdf']"
							v-model="fileList"
							@success="handleUploadSuccess"
							:showTip="false"
							title="上传合同附件"></FileUpload>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>

		<!-- footer -->
		<template #footer>
			<el-button @click="handleClose">取消</el-button>
			<el-button type="primary" @click="handleSubmit">确定</el-button>
		</template>
	</el-dialog>
</template>

<script>
	export default {
		name: 'ContractManagementAddDialog',
		props: {
			dialogVisible: Boolean,
		},
		watch: {
			dialogVisible(val) {
				if (val) {
					this.$nextTick(() => {
						this.$refs.form && this.$refs.form.resetFields();
					});
				}
			},
		},
		data() {
			return {
				form: {
					contractNo: 'HT-202604-000004',
					contractName: '',
					partyA: '南京智慧物业有限公司',
					partyB: '',
					projectId: '',
					businessType: '',
					contractType: '',
					amount: null,
					startDate: '',
					endDate: '',
					fileUrl: '',
				},
				rules: {
					contractName: [{ required: true, message: '请输入合同名称', trigger: 'blur' }],
					partyB: [{ required: true, message: '请输入乙方', trigger: 'blur' }],
					projectId: [{ required: true, message: '请选择关联项目', trigger: 'change' }],
					businessType: [{ required: true, message: '请选择经营类型', trigger: 'change' }],
					contractType: [{ required: true, message: '请选择合同类型', trigger: 'change' }],
					startDate: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
					endDate: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
				},
				fileList: [],
				tableDataB: [
					{
						partnerName: '南京创新科技有限公司',
						partnerCategory: '租赁商',
						contactPerson: '张三',
						contactPhone: '13800138001',
					},
					{
						partnerName: '李四军',
						partnerCategory: '委托业主',
						contactPerson: '李四',
						contactPhone: '13900139002',
					},
					{
						partnerName: '南京房产经纪有限公司',
						partnerCategory: '中介商',
						contactPerson: '王五',
						contactPhone: '13700137003',
					},
					{
						partnerName: '南京停车管理有限公司',
						partnerCategory: '维保商',
						contactPerson: '赵六',
						contactPhone: '13600136004',
					},
				],
				tableData: [
					{
						projectNo: 'XM-20260421-0001',
						projectName: 'A栋广告位创新租赁',
						businessType: '创新租赁',
						status: '进行中',
					},
					{
						projectNo: 'XM-20260420-0002',
						projectName: 'B栋委托租售项目',
						businessType: '委托租售',
						status: '进行中',
					},
					{
						projectNo: 'XM-20260315-0003',
						projectName: '停车场增值服务',
						businessType: '增值服务',
						status: '已结项',
					},
					{
						projectNo: 'XM-20260422-0004',
						projectName: 'C栋房产经纪项目',
						businessType: '房产经纪',
						status: '筹备中',
					},
				],
			};
		},
		methods: {
			handleClose() {
				this.$emit('update:dialogVisible', false);
			},
			handleUploadSuccess(response, file, fileList) {
				if (response.code === 0) {
					this.form.voucherUrl = response.data;
					this.$message.success('文件上传成功');
				} else {
					this.$message.error('文件上传失败');
				}
			},
			handleUploadError(err, file, fileList) {
				this.$message.error('文件上传失败');
			},
			handleSelectB(row) {},
			handleSubmit() {
				this.$refs.form.validate(valid => {
					if (!valid) return;
				});
			},
		},
	};
</script>

<style scoped lang="scss">
	:deep(.depreciation-dialog) {
		.no-spinner .el-input__inner::-webkit-outer-spin-button,
		.no-spinner .el-input__inner::-webkit-inner-spin-button {
			-webkit-appearance: none;
			margin: 0;
		}

		.no-spinner .el-input__inner[type='number'] {
			-moz-appearance: textfield; /* Firefox */
		}

		.el-dialog__body {
			max-height: 60vh; // 控制最大高度
			overflow-y: auto; // 开启纵向滚动
		}
		/* 整体滚动条宽度 */
		.el-dialog__body::-webkit-scrollbar {
			width: 6px;
		}

		/* 滚动条轨道 */
		.el-dialog__body::-webkit-scrollbar-track {
			background: #f5f5f5;
			border-radius: 3px;
		}

		/* 滑块 */
		.el-dialog__body::-webkit-scrollbar-thumb {
			background: #bbbbbb;
			border-radius: 3px;
			transition: all 0.3s;
		}

		/* hover 时 */
		.el-dialog__body::-webkit-scrollbar-thumb:hover {
			background: #a8a8a8;
		}
	}

	.cards {
		margin-bottom: 20px;
	}
</style>
